import React from "react";
import { Check } from "lucide-react";
import { Button } from "src/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/ui/dialog";

export default function MarkPaid({ salary, data, onClick, setOpen, open }) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button title="Mark as Paid" disabled={salary?.hold?.released_at}>
          <Check className="h-4 w-4" /> Confirm Payment
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm Payment</DialogTitle>
          <DialogDescription>
            Are you sure you want to mark the salary for{" "}
            <strong>{data?.user?.name}</strong> as paid?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button onClick={onClick}>Confirm</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
